module.exports = __webpack_public_path__ + "static/img/background.1bbb605.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/background.png
// module id = N3vg
// module chunks = 1